import Vue from "vue";
import App from "./client/App.vue";
import router from "./server/router";
import { store } from "./server/store.js";

import "./server/registerServiceWorker";

import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(fab);
library.add(fas);
import "./client/assets/scss/normalize.css";
import "./client/assets/scss/app.scss";
import "./client/assets/scss/fonts.scss";

//const fb = require("./firebaseConfig.js");
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App),
  components: { App },
});
